// extracted by mini-css-extract-plugin
var _1 = "LabelsCell_addButton__Jrsfj";
var _2 = "LabelsCell_iconAddButton__9zrod";
var _3 = "LabelsCell_labelWrapper__KoqeM";
var _4 = "LabelsCell_popupWrapper__U4v20";
export { _1 as "addButton", _2 as "iconAddButton", _3 as "labelWrapper", _4 as "popupWrapper" }
